import {clear, mdash, applyVatIfNeeded} from 'legacy/utils';
import {autonumeric2toLocaleStringOptions} from 'legacy/modules/common/components/MNumericInput/utils';
import * as configs from 'legacy/modules/common/components/MNumericInput/MNumericInputConfigurations';
import numeral from 'numeral';
import 'numeral/locales/ru';
import sellerStore from 'store/indexSeller';
import store from 'store';
import {isCurrentAppSeller} from 'utils/appTypeState';

const currentLocale = () => (isCurrentAppSeller()
    ? sellerStore.getters['sellerUser/userLocale']
    : store.getters['user/userLocale']) || 'ru';


function getOptionForType (type, options, value) {
    return autonumeric2toLocaleStringOptions((configs[type] || configs.defaults)(clear({
        minimumValue: options.minimumValue,
        maximumValue: options.maximumValue,
        symbol: options.symbol,
        negative: options.negative,
        allowDecimalPadding: options.allowDecimalPadding,
        decimalPlaces: options.decimalPlaces
    }), value));
}

function parseNumber (value, options) {
    if (typeof value === 'number') {
        return value;
    }

    // is integer
    if (options.decimalPlaces === 0) {
        return Math.round(value);
    }

    return parseFloat(value);
}

function formatShortenNumber (value, {type, shortenDecimalPlaces = 1}) {
    let pattern = `0.${'0'.repeat(shortenDecimalPlaces)} a`;
    if (type === 'integer' && value < 1000) {
        pattern = '0 a';
    }
    numeral.locale(currentLocale());
    return numeral(value).format(pattern).
        trimEnd();
}

/**
 * Convert raw numeric value (String, Number) to formatted numeric value
 * (with spaces, decimal part and currency/type symbol)
 * @param rawValue
 * @param type {String} - type of numeric value (currency, decimal, percent...)
 * @param options {Object}
 * {
 *   withCurrencySymbol - add currency symbol for 'currency' type
 *   ...otherAutonumeric params
 * }
 *  withCurrencySymbol: true
 * @returns {string|number}
 */
export default function (rawValue, type, options = {}) {
    const numericOptions = getOptionForType(type, options, rawValue);

    let value = applyVatIfNeeded(rawValue, options.vat);
    value = parseNumber(value, numericOptions);
    if (isNaN(value)) {
        return mdash;
    }

    let number;

    if (options.shortenNumber) {
        number = formatShortenNumber(value, {type, shortenDecimalPlaces: options.shortenDecimalPlaces});
    } else {
        /*
         * if currency or percent replace type with decimal not to add symbol
         * minimumFractionDigits to add leading zeroes;
         */
        if (type === 'decimal' || type === 'currency' || type === 'percent') {
            numericOptions.style = 'decimal';
        }

        number = typeof value === 'number' ? value.toLocaleString(
            currentLocale(),
            numericOptions
        ) : value;
    }
    if ((options.withCurrencySymbol || type === 'percent') && numericOptions.currencySymbol) {
        switch (numericOptions.currencySymbolPlacement) {
        case 'p':
            number = `${numericOptions.currencySymbol}${number}`;
            break;
        case 's':
            number = `${number}${numericOptions.currencySymbol}`;
            break;
        default:

            // do nothing
        }
    }
    return number;
}
